export interface Traveller {
  name: string;
  surname: string;
  personalNumber: string;
  birthDate: string;
}

export interface listOfTravellerCountPerAgeRange {
  travellerAgeRangeId: number,
  travellerCount: number
}

export interface PolicyOptions {
  id: number;
  name: string;
  description: string;
  price: number;
  limit: string;
  state: string;
  details: object[];
  enabled: boolean;
  available: boolean;
}

export interface Franchise {
  id: number;
  name: string;
  price: string;
  state: string;
}

export interface Insurance {
  contactFirstName: string;
  contactLastName: string;
  contactPersonalNUmber: string;
  contactBirthDate: string;
  contactEmail: string;
  contactMobileNumber: string;
  contactSmsCode: string;
  traveller: Traveller[];
  insuranceStartingDate: string;
  insuranceEndingDate: any;
  policyType: number;
  franchiseType: number;
  currency: string;
  promoCode: string;
}

export interface Calculate {
  travelTypeId: number;
  withCovid: boolean;
  travelPeriodInDays: number;
  travelFranchiseTypeId: number;
  listOfTravellerCountPerAgeRange: listOfTravellerCountPerAgeRange[];
}

export class CreateApplicationRequest {
  constructor() {}

  productId: number;
  travelTypeId: number;
  startDate: Date;
  endDate: Date;

  withCovid: boolean;
  travelFranchiseTypeId: number;

  travelPeriodInDays: number;

  insurer: Person;
  travellers: Person[];
  countryIds: string[];
}

export class Person {
  firstName: string;
  lastName: string;
  personalId: string;
  dateOfBirth: Date;
  email: string;
  phone: string;
}

export interface PolicyObject {
  InsuranceType: { type: string };
  InsuranceDays: {
    days: number
  }
  InsurancePeriod: 
    {
     startDate: Date;
     endDate: Date;
    };

  PolicyType: 
    {
      currency: string;
      franchise: boolean;
      covid: boolean;
      policy: string;
    };
  ContactInfo: {
    email: string;
    phone: string;
  };

  PersonalInfo: Traveller;
  PassengerInfo: Traveller[];
}

export interface CreateApplicationResponse {
  policyApplicationId: number;
  applicationNumber: string;
  policyCode: string;
  token: string;
}


export interface PaymentConfig {
  PAY_URL: string;
  BASE_URL: string;
}
